import { useEffect, useState } from "react";

export function useBlobUrl(client, path, enabled = true) {
  const [url, setUrl] = useState(null);
  const [error, setError] = useState(false);
  useEffect(() => {
    if (!path || !enabled) {
      return undefined;
    }
    let alive = true;
    let made = null;
    client
      .get(path, { responseType: "blob" })
      .then((r) => {
        made = URL.createObjectURL(r.data);
        if (alive) setUrl(made);
      })
      .catch(() => alive && setError(true));
    return () => {
      alive = false;
      if (made) URL.revokeObjectURL(made);
    };
  }, [client, path, enabled]);
  return { url, error };
}

export async function openBlob(client, path) {
  const w = window.open("", "_blank");
  const r = await client.get(path, { responseType: "blob" });
  const u = URL.createObjectURL(r.data);
  if (w) w.location.href = u;
  else window.location.href = u;
}
